interface MasterDataServiceParams {
  apiRequest: (url: string, options?: RequestInit) => Promise<any>;
}

export const createMasterDataService = ({
  apiRequest,
}: MasterDataServiceParams) => ({
  // Departments
  getDepartments: async (options?: { all?: boolean; showDeleted?: boolean }): Promise<any> => {
    const params = new URLSearchParams();
    if (options?.showDeleted) params.append("showDeleted", "true");
    if (options?.all) params.append("all", "true");
    const queryStr = params.toString() ? `?${params.toString()}` : "";
    const data = await apiRequest(`/master-data/departments${queryStr}`);
    return data;
  },
  createDepartment: async (data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/departments`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },
  updateDepartment: async (id: string, data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/departments/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },
  deleteDepartment: async (id: string): Promise<any> => {
    const res = await apiRequest(`/master-data/departments/${id}`, { method: "DELETE" });
    return res;
  },

  // Designations (Posts)
  getDesignations: async (category?: string, options?: { all?: boolean; showDeleted?: boolean }): Promise<any> => {
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (options?.showDeleted) params.append("showDeleted", "true");
    if (options?.all) params.append("all", "true");
    const queryStr = params.toString() ? `?${params.toString()}` : "";
    const res = await apiRequest(`/master-data/designations${queryStr}`);
    return res;
  },
  createDesignation: async (data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/designations`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },
  updateDesignation: async (id: string, data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/designations/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },
  deleteDesignation: async (id: string): Promise<any> => {
    const res = await apiRequest(`/master-data/designations/${id}`, { method: "DELETE" });
    return res;
  },

  // Instructions
  getInstructions: async (module?: string, options?: { all?: boolean; showDeleted?: boolean }): Promise<any> => {
    const params = new URLSearchParams();
    if (module) params.append("module", module);
    if (options?.showDeleted) params.append("showDeleted", "true");
    if (options?.all) params.append("all", "true");
    const queryStr = params.toString() ? `?${params.toString()}` : "";
    const res = await apiRequest(`/master-data/instructions${queryStr}`);
    return res;
  },
  createInstruction: async (data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/instructions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },
  updateInstruction: async (id: string, data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/instructions/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },
  deleteInstruction: async (id: string): Promise<any> => {
    const res = await apiRequest(`/master-data/instructions/${id}`, { method: "DELETE" });
    return res;
  },

  // Bank Account
  getBankAccount: async (): Promise<any> => {
    const res = await apiRequest(`/account`);
    return res;
  },
  saveBankAccount: async (data: any): Promise<any> => {
    const res = await apiRequest(`/account`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  },

  // Seed
  seedData: async (data: any): Promise<any> => {
    const res = await apiRequest(`/master-data/seed`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res;
  }
});
